export enum AllowanceType {
  INSTAY,
  VEC,
}

export interface Allowance {
  cardtype: AllowanceType;
  options: AllowanceOptionCreate[];
}

interface AllowanceOption {
  id: number;
  value: string;
}

export interface SelectedAllowance {
  name: string;
  id: AllowanceType | null;
  isSelected?: boolean;
}

export interface AllowanceOptionCreate extends AllowanceOption {
  hotelnote: string;
}

export interface AllowanceOptionSelected extends AllowanceOption {
  hotelNote: string;
}

export interface GetAllowancesResponse {
  data: Allowance[];
  success: boolean;
}

export interface AddAllowanceResponse {
  success: boolean;
}

export enum AddAllowanceStatus {
  Success = 'SUCCESS',
  Failed = 'FAILED',
}

export interface AllowanceOptionSelected extends AllowanceOption {
  hotelNote: string;
}
